import {
  get_fastSeconds3ld6xqdi008l3 as get_fastSeconds,
  _FastDuration___get_seconds__impl__4kvvavkn2srn5t4e0w as _FastDuration___get_seconds__impl__4kvvav,
  get_CoreTime23yr4od90u6o9 as get_CoreTime,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  _FastDuration___get_microseconds__impl__o4j93h2rn63lkq7a8kl as _FastDuration___get_microseconds__impl__o4j93h,
  get_slowaqovrrnrezzv as get_slow,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  Companion_instance3gshkh79a96f7 as Companion_instance,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2au1ep9vhcato as equals,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class PerformanceCounter {
  constructor() {
    PerformanceCounter_instance = this;
    this.l64_1 = nowMillis(this);
  }
  m64() {
    return _FastDuration___get_nanoseconds__impl__pxizcb(ellapsed(this));
  }
  n64() {
    return _FastDuration___get_microseconds__impl__o4j93h(ellapsed(this));
  }
  o64() {
    return get_slow(ellapsed(this));
  }
  p64() {
    return ellapsed(this);
  }
}
class Stopwatch {
  constructor(nanosecondProvider) {
    var tmp;
    if (nanosecondProvider === VOID) {
      tmp = Stopwatch$_init_$lambda_lg3mf2;
    } else {
      tmp = nanosecondProvider;
    }
    nanosecondProvider = tmp;
    this.q64_1 = nanosecondProvider;
    this.r64_1 = false;
    this.s64_1 = 0.0;
  }
  t64() {
    return this.r64_1 ? _get_currentNano__jndyu4(this) - this.s64_1 : this.s64_1;
  }
  u64() {
    return get_fastNanoseconds(this.t64());
  }
}
class IntTimedCache {
  constructor(ttl, timeProvider, gen) {
    timeProvider = timeProvider === VOID ? Companion_instance : timeProvider;
    this.v64_1 = ttl;
    this.w64_1 = timeProvider;
    this.x64_1 = gen;
    this.y64_1 = Companion_getInstance().j1u_1;
    this.z64_1 = 0;
  }
  ko(obj, property) {
    // Inline function 'korlibs.time.IntTimedCache.get' call
    var now = this.w64_1.n1u();
    if (equals(this.y64_1, Companion_getInstance().j1u_1) || Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8(now, this.y64_1), this.v64_1) >= 0) {
      this.y64_1 = now;
      this.z64_1 = this.x64_1();
    }
    return this.z64_1;
  }
}
//endregion
function _Frequency___init__impl__upasnx(hertz) {
  return hertz;
}
function _Frequency___get_hertz__impl__9m7k6x($this) {
  return $this;
}
function _Frequency___get_fastDuration__impl__87web0($this) {
  return get_fastSeconds(1.0 / _Frequency___get_hertz__impl__9m7k6x($this));
}
function toFrequency(_this__u8e3s4) {
  return get_timesPerSecond_0(_this__u8e3s4);
}
function get_timesPerSecond(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(_this__u8e3s4);
}
function get_timesPerSecond_0(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(1.0 / _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4));
}
var KlockLocale_default;
function nowMillis($this) {
  return get_CoreTime().x1u();
}
function ellapsed($this) {
  return get_fastMilliseconds(nowMillis($this) - $this.l64_1);
}
var PerformanceCounter_instance;
function PerformanceCounter_getInstance() {
  if (PerformanceCounter_instance === VOID)
    new PerformanceCounter();
  return PerformanceCounter_instance;
}
function _get_currentNano__jndyu4($this) {
  return $this.q64_1();
}
function Stopwatch$_init_$lambda_lg3mf2() {
  return PerformanceCounter_getInstance().m64();
}
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
initMetadataForObject(PerformanceCounter, 'PerformanceCounter');
initMetadataForClass(Stopwatch, 'Stopwatch', Stopwatch);
initMetadataForClass(IntTimedCache, 'IntTimedCache');
//endregion
//region block: init
KlockLocale_default = null;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  _Frequency___get_fastDuration__impl__87web0 as _Frequency___get_fastDuration__impl__87web01nqjqeilxp91g,
  _Frequency___get_hertz__impl__9m7k6x as _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1,
  PerformanceCounter_getInstance as PerformanceCounter_getInstance3b8d94s1bsc37,
  IntTimedCache as IntTimedCache39ymx9abjz88x,
  Stopwatch as Stopwatch1guqi4xl0rpfb,
  get_timesPerSecond as get_timesPerSecond1juuclsmjle05,
  toFrequency as toFrequency3flbtmp5xney7,
};
//endregion
